import { Building2, Home, Landmark, LockKeyhole, TrainFront, Zap } from 'lucide-react';
import { formatMoney, GROUP_COLORS } from '../utils/board.js';

function typeLabel(cell) {
  if (cell.type === 'street') return 'Улица';
  if (cell.type === 'transport') return 'Транспортный объект';
  if (cell.type === 'utility') return 'Коммунальное предприятие';
  return 'Клетка поля';
}

export function PropertyPanel({ game, cellIndex }) {
  const cell = game.board[cellIndex] ?? game.board[game.currentPlayer?.position ?? 0];
  const property = game.properties.find((item) => item.id === cell.index);
  const owner = property?.ownerId ? game.players.find((player) => player.id === property.ownerId) : null;

  return (
    <section className="panel property-panel" aria-labelledby="property-heading" style={{ '--property-color': GROUP_COLORS[cell.group] ?? '#274b61' }}>
      <div className="property-panel__stripe" />
      <header>
        <div>
          <span>Клетка {cell.index} · {typeLabel(cell)}</span>
          <h2 id="property-heading">{cell.name}</h2>
        </div>
        {cell.type === 'transport' ? <TrainFront size={25} /> : cell.type === 'utility' ? <Zap size={25} /> : <Building2 size={25} />}
      </header>

      {property ? (
        <>
          <dl>
            <div><dt>Стоимость</dt><dd>{formatMoney(cell.price)}</dd></div>
            <div><dt>Базовая аренда</dt><dd>{formatMoney(cell.rents[0])}</dd></div>
            {cell.buildCost && <div><dt>Строительство</dt><dd>{formatMoney(cell.buildCost)}</dd></div>}
            <div><dt>Ипотека</dt><dd>{formatMoney(cell.mortgageValue)}</dd></div>
          </dl>
          <div className="property-state">
            {owner ? <><span className="owner-swatch" style={{ background: owner.color }} /><span>Владелец: <strong>{owner.name}</strong></span></> : <><Landmark size={17} /><span>Свободный объект</span></>}
            {property.mortgaged && <span className="state-chip"><LockKeyhole size={14} /> В ипотеке</span>}
            {property.houses > 0 && <span className="state-chip"><Home size={14} /> {property.houses === 5 ? 'Отель' : `Домов: ${property.houses}`}</span>}
          </div>
        </>
      ) : (
        <p className="property-panel__description">Специальная клетка. Её эффект рассчитывается сервером сразу после перемещения.</p>
      )}
    </section>
  );
}
